/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UploadImageService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param formData 
     * @returns any Success
     * @throws ApiError
     */
    public postApiUploadImage(
formData?: {
Name?: string;
Images?: Array<Blob>;
},
): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/UploadImage',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
